var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArkcBlackBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z",
    fill: "#2F2F2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4908 27.2686L15.7346 21.8551L18.9093 25.0268L13.4908 27.2686ZM20.7995 26.3139L22.0476 23.2873L17.4032 18.6528L14.3719 19.9093L12 17.5377L26.4684 12L28.7619 14.2914L23.2288 28.7619L20.7995 26.3139Z",
    fill: "#B1B1B1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArkcBlackBg);
export default __webpack_public_path__ + "static/media/arkc-black-bg.04a1c75bcb68d932b9eb6ece0211458a.svg";
export { ForwardRef as ReactComponent };